module.exports = __webpack_public_path__ + "img/tn-stock-3.8c2f6ed5.jpeg";